import type { CountryCode } from 'ms-pages/FreeTextbooks/types';

// !!! The paths here MUST be in sync with the URLs in `msproblem/interface/textbooks/sitemap.py` !!!
export const freeTextbooksHomePath = '/textbooks';
export const freeTextbooksBasePath = `${freeTextbooksHomePath}/syllabuses`;

// SyllabusSelector
// CurriculumSelector

export const freeTextbooksRootSelector = `${freeTextbooksBasePath}/select`;

export const freeTextbooksCurriculumSelectorPath = `${freeTextbooksBasePath}/select/:countryCode`;
export type FreeTextbooksCurriculumSelectorUrlParams = {
  countryCode: CountryCode;
};

export const getCurriculumSelectorUrl = ({
  countryCode,
}: FreeTextbooksCurriculumSelectorUrlParams) =>
  `${freeTextbooksBasePath}/select/${countryCode}`;

// TextbookSelector

export const freeTextbooksTextbookSelectorPath = `${freeTextbooksBasePath}/select/:countryCode/:curriculumId`;
export type FreeTextbooksTextbookSelectorUrlParams = {
  countryCode: CountryCode;
  curriculumId: string;
};

export const getTextbookSelectorUrl = ({
  countryCode,
  curriculumId,
}: FreeTextbooksTextbookSelectorUrlParams) =>
  `${freeTextbooksBasePath}/select/${countryCode}/${curriculumId}`;

// SYLLABUS EMPTY VIEW
export type FreeTextbooksEmptyViewUrlParams = {
  syllabusId: string;
};
export const freeTextbooksEmptyViewPath = `${freeTextbooksBasePath}/:syllabusId/`;
export const getFreeTextbooksEmptyViewUrl = ({
  syllabusId,
}: FreeTextbooksEmptyViewUrlParams) =>
  `${freeTextbooksBasePath}/${syllabusId}/`;

// TOPIC EMPTY VIEW
export const freeTextbooksTopicEmptyViewPath = `${freeTextbooksBasePath}/:syllabusId/topics/:topicId`;
export type FreeTextbooksTopicEmptyViewUrlParams = {
  syllabusId: string;
  topicId: string;
};
export const getFreeTextbooksTopicEmptyViewUrl = ({
  syllabusId,
  topicId,
}: FreeTextbooksTopicEmptyViewUrlParams) =>
  `${freeTextbooksBasePath}/${syllabusId}/topics/${topicId}/`;

// SUBTOPIC DETAIL
export const freeTextbooksSubtopicDetailViewPath = `${freeTextbooksBasePath}/:syllabusId/topics/:topicId/subtopics/:subtopicId/`;
export type FreeTextbooksSubtopicDetailViewUrlParams = {
  syllabusId: string;
  topicId: string;
  subtopicId: string;
};
export const getFreeTextbooksSubtopicDetailViewUrl = ({
  syllabusId,
  topicId,
  subtopicId,
}: FreeTextbooksSubtopicDetailViewUrlParams) =>
  `${freeTextbooksBasePath}/${syllabusId}/topics/${topicId}/subtopics/${subtopicId}/`;
